
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { store, ShopModule }  from "@returns-centre/store";

@Component
export default class AppActionButton extends Vue {
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) outline!: boolean;
    @Prop({ default: false }) disableCustomStyle!: boolean;
    @Prop({ default: false }) isProcessing!: boolean;
    @Prop({ default: false }) disableButtonCss!: boolean;

    shopModule = getModule(ShopModule, store);

    get getActionButtonStyle() {
        if(!this.shopModule.shop || this.disableCustomStyle) {
            return {};
        }

        if (this.outline) {
            return {
                backgroundColor: this.disableButtonCss ? '#ffffff' : this.shopModule.shop.return_centre_primary_action_color,
                color: this.disableButtonCss ? '#000000' : this.shopModule.shop.return_centre_primary_action_background_color,
                border: '1px solid ' + (this.disableButtonCss ? '#000000' : this.shopModule.shop.return_centre_primary_action_background_color),
            };
        }

        return {
            backgroundColor: this.disableButtonCss ? '#000000' : this.shopModule.shop.return_centre_primary_action_background_color,
            color: this.disableButtonCss ? '#ffffff' : this.shopModule.shop.return_centre_primary_action_color,
            border: '1px solid ' + (this.disableButtonCss ? '#000000' : this.shopModule.shop.return_centre_primary_action_background_color),
        };
    }

    onClick() {
        if(this.disabled) { return; }
        this.$emit('click')
    }
}
